import { FaLock } from 'react-icons/fa'
import { useAppSelector, useIconSize } from '@app/hooks';
import { useMemo } from 'react';
import { Tooltip, TooltipTrigger, TooltipContent } from '@components/tooltip/Tooltip';
import { selectCurrentUser } from '@app/features/auth/authSlice';
import TranslatableText from '@components/translations/TranslatableText';
import { useHybridLockStatus } from '@app/hooks/useHybridLockStatus';

const LockBanner = () => {
  const { lockInfo } = useHybridLockStatus();
	const user = useAppSelector(selectCurrentUser);
  const iconSize = useIconSize(14); 

  const isLockedByMe = useMemo(() => user?.email === lockInfo?.locked_by, [lockInfo?.locked_by, user]);
  const lockedAt = useMemo(() => {
    if (lockInfo?.locked_at) {
      const date = new Date(lockInfo.locked_at);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    }
    return 'Unknown';
  }, [lockInfo?.locked_at]);
  const lockUpdatedAt = useMemo(() => {
    if (lockInfo?.lock_updated_at) {
      const date = new Date(lockInfo.lock_updated_at);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    }
    return 'Unknown';
  }, [lockInfo?.lock_updated_at]);

  return (
    <div className="d-flex h-100 align-items-center w-fit">
      {lockInfo?.is_locked && (
        <Tooltip placement="bottom" initialOpen={false}>
          <TooltipTrigger asChild>
            <div className="d-flex align-items-center gap-4" style={{ cursor: 'pointer' }}>
              <FaLock size={iconSize} color="var(--tertiary-dark)" style={{ marginBottom: "4px" }} />
              <TranslatableText translationKey='project.locked' className='fs-14 ff-bold-cond text-darker-gray' />
            </div>
          </TooltipTrigger>
          <TooltipContent className='lock-tooltip'>
            <div className="d-flex f-column" style={{ gap: '4px' }}>
              <div>
                <TranslatableText
                  translationKey={isLockedByMe ? 'project.project_locked_by_you' : 'project.project_locked_by'}
                  translationParams={{ user: lockInfo?.locked_by || 'Unknown User' }}
                  className='fs-12 fw-medium'
                />
              </div>
              <div>
                <TranslatableText
                  translationKey='project.locked_at'
                  translationParams={{ date: lockedAt }}
                  className='fs-11 text-muted'
                />
              </div>
              <div>
                <TranslatableText
                  translationKey='project.last_activity'
                  translationParams={{ date: lockUpdatedAt }}
                  className='fs-11 text-muted'
                />
              </div>
            </div>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};

export default LockBanner;